import * as React from "react";

export interface LoginAppConsumerInterface {
  shouldLoginUsingTheSpecialAsynchronousApiInsteadOfFormPost?: boolean;
  shouldContinueLoadingAfterLoginSuccess?: boolean;
}
const defaultValue = {} as unknown as LoginAppConsumerInterface;
const LoginAppContext = React.createContext(defaultValue);

export const LoginAppProvider: React.FunctionComponent<
  LoginAppConsumerInterface
> = (props) => {
  const value: LoginAppConsumerInterface = React.useMemo(
    () => ({
      ...props,
    }),
    [props]
  );
  return (
    <LoginAppContext.Provider value={value}>
      {props.children || []}
    </LoginAppContext.Provider>
  );
};

export const useLoginApp = () => {
  const context = React.useContext(LoginAppContext);
  if (context === defaultValue) {
    throw new Error("useLoginApp must be used within a LoginAppProvider");
  }
  return context;
};
